<template>
  <v-card>
    <v-system-bar color="#6b5cd7" dark>
      Aperçu de mon message
      <v-spacer></v-spacer>
      <v-icon @click="dialog = false">close</v-icon>
    </v-system-bar>
    <v-row class="ma-0 pt-0">
      <v-col cols="1" align="center" class="no-padding">
        <v-avatar class="mt-2" color="#ebedf4" size="45"
          ><v-img src="@/assets/images/placeholder-profile_3_7.png" alt="PA"
        /></v-avatar>
      </v-col>
      <v-col cols="11" class="no-padding">
          <strong class="grey--text">Envoyé à:&nbsp;</strong>
        <v-card-text class="ma-0 pa-1">virgile@sayhook.fr</v-card-text>
        <v-divider/>
        <strong class="grey--text">Objet:&nbsp;</strong>
          <v-card-text 
            class="ma-0 pa-1"
            v-html="scenario_preview.label"
          >
          </v-card-text>
        <v-col cols="12" align="center" style="background-color: $color-primary">
          <div class="pa-3 mb-3">
            <v-avatar
              color="white"
              size="75"
              rounded
              class="text color-purple-base"
              >Logo Importé CHR
              <template v-if="preview">
                <img :src="preview" class="img-fluid" />
              </template>
            </v-avatar>
          </div>
          <v-card-text 
            v-html="scenario_preview.content"
            style="background-color: white">
          </v-card-text>
          <div class="pt-4">
            <v-card-text
              class="mentions pb-0"
              style="color: white"
            ></v-card-text>
            <v-card-text class="mentions" style="color: white"></v-card-text>
          </div>
        </v-col>
        <v-col cols="12" align="center" class="pt-4">
          <v-btn
            outlined
            class="mr-4 theme-btn shape-rounded email-modify"
            style="color: #6b5cd7"
            @click="dialog = false"
            ><strong>Modifier</strong></v-btn
          >
          <v-btn 
            class="ml-4 theme-btn shape-rounded filled-purple"
            @click="dialog = false"
            >Je valide mon email
          </v-btn>
        </v-col>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import TextEditorTipTap from "./textarea-editor-tiptap.vue";

export default {
  components: {
    TextEditorTipTap,
  },
  data: () => {
    return {
      dialog: false,
      preview: null,
    };
  },
  props: {
    scenario_preview: {
      type: Object,
      default: () => {
        return {
            
        };
      },
    },
  },
  created() {
     
  }
};
</script>
                                                            
                                                   